import { render, staticRenderFns } from "./Semaforo.vue?vue&type=template&id=2b77d710&scoped=true&"
import script from "./Semaforo.vue?vue&type=script&lang=js&"
export * from "./Semaforo.vue?vue&type=script&lang=js&"
import style0 from "./Semaforo.vue?vue&type=style&index=0&id=2b77d710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77d710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b77d710')) {
      api.createRecord('2b77d710', component.options)
    } else {
      api.reload('2b77d710', component.options)
    }
    module.hot.accept("./Semaforo.vue?vue&type=template&id=2b77d710&scoped=true&", function () {
      api.rerender('2b77d710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Semaforo.vue"
export default component.exports